import React, { useCallback, useContext } from 'react';
import useTranslations from '../../../hooks/useTranslations';
import { FetchCallbacksContext } from '../../FetchCallbacks';
import SchedularSettingsQueryView from '../view/SchedularSettingsQueryView';

export const Days = {
  7: 'form-builder.reminders.days.sunday',
  1: 'form-builder.reminders.days.monday',
  2: 'form-builder.reminders.days.tuseday',
  3: 'form-builder.reminders.days.wednesday',
  4: 'form-builder.reminders.days.thursday',
  5: 'form-builder.reminders.days.friday',
  6: 'form-builder.reminders.days.saturday'
};

export const addNumSuffix = i => {
  var j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + 'st';
  }
  if (j === 2 && k !== 12) {
    return i + 'nd';
  }
  if (j === 3 && k !== 13) {
    return i + 'rd';
  }
  return i + 'th';
};

const SchedularSettingsQueryEngine = ({ reminderData, update }) => {
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const t = useTranslations();

  const onWhenChanged = useCallback(
    value => {
      const updateValue = {};
      if (value === 'soon') {
        // updateValue['recurrence.recurrenceType'] = 'submission';
        updateValue.recurrence = undefined;
      } else {
        updateValue['recurrence.recurrenceType'] = 'time';
        updateValue['recurrence.intervalUnit'] = value;
        updateValue['recurrence.hourOfDay'] =
          reminderData &&
          reminderData.recurrence &&
          reminderData.recurrence.hourOfDay
            ? reminderData.recurrence.hourOfDay
            : '0';
        updateValue['recurrence.dayOfWeek'] = '1';
        updateValue['recurrence.dayOfMonth'] = '1';
      }
      update(updateValue);
    },
    [reminderData]
  );
  const onDayOfTheWeekSelected = useCallback(
    value => {
      update({ 'recurrence.dayOfMonth': value });
      if (parseInt(value) > 28) {
        openSnackbar('warning', t('form-builder.reminders.days.warning'), true);
      }
    },
    [reminderData]
  );

  const getWhen = useCallback(() => {
    if (
      reminderData &&
      reminderData.recurrence &&
      reminderData.recurrence.recurrenceType === 'time'
    ) {
      return reminderData.recurrence.intervalUnit;
    }
    return 'soon';
  }, [reminderData]);

  const getHourOfDay = useCallback(() => {
    if (reminderData && reminderData.recurrence) {
      return reminderData.recurrence.hourOfDay;
    }
    return -1;
  }, [reminderData]);

  const getDayOfWeek = useCallback(() => {
    if (reminderData && reminderData.recurrence) {
      return reminderData.recurrence.dayOfWeek;
    }
    return -1;
  }, [reminderData]);

  const getDayOfMonth = useCallback(() => {
    if (reminderData && reminderData.recurrence) {
      return reminderData.recurrence.dayOfMonth;
    }
    return -1;
  }, [reminderData]);

  const isTimeIntervalEqualTo = useCallback(
    unit =>
      reminderData &&
      reminderData.recurrence &&
      reminderData.recurrence.recurrenceType === 'time' &&
      reminderData.recurrence.intervalUnit === unit,
    [reminderData]
  );

  const viewProps = {
    reminderData,
    update,
    when: getWhen(),
    hourOfDay: getHourOfDay(),
    dayOfWeek: getDayOfWeek(),
    dayOfMonth: getDayOfMonth(),
    showAt: getWhen() !== 'soon', // lack support in back-end
    showOnWeek: isTimeIntervalEqualTo('week'),
    showOnMonth: isTimeIntervalEqualTo('month'),
    onWhenChanged,
    onDayOfTheWeekSelected
  };

  return <SchedularSettingsQueryView {...viewProps} />;
};

export default SchedularSettingsQueryEngine;
